import React, { useEffect, useRef, useState } from "react";
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom";
import { session } from "../api.js";
import { useContent } from "../cms/store.js";
import NotificationBell from "./NotificationBell.jsx";
import { Icon } from "./icons.jsx";

const MAIN = [
  { to: "/", label: "Strona główna" },
  { to: "/jak-to-dziala", label: "Jak to działa" },
  { to: "/cennik", label: "Cennik" },
  { to: "/baza-wiedzy", label: "Baza wiedzy" },
];

const ABOUT = [
  { to: "/o-nas", t: "O nas i misja", d: "Po co powstaliśmy i kto podpisuje odpowiedzi" },
  { to: "/faq", t: "Pytania i odpowiedzi", d: "Usługa, płatności, terminy, dane" },
  { to: "/kontakt", t: "Kontakt", d: "Napisz do zespołu prawly" },
];

export default function Header({ onLogout }) {
  const settings = useContent("settings");
  const me = session.get()?.user;
  const loc = useLocation();
  const nav = useNavigate();

  const [drop, setDrop] = useState(false);
  const [drawer, setDrawer] = useState(false);
  const groupRef = useRef(null);

  /* zamknij menu przy zmianie trasy */
  useEffect(() => {
    setDrop(false);
    setDrawer(false);
  }, [loc.pathname]);

  /* klik poza dropdownem i Escape */
  useEffect(() => {
    const onDown = (e) => {
      if (groupRef.current && !groupRef.current.contains(e.target)) setDrop(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") {
        setDrop(false);
        setDrawer(false);
      }
    };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  /* blokada przewijania pod szufladą */
  useEffect(() => {
    document.body.style.overflow = drawer ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [drawer]);

  const logout = () => {
    onLogout?.();
    setDrawer(false);
    nav("/");
  };

  const panelLink =
    me?.role === "lawyer"
      ? { to: "/prawnik", label: "Kolejka spraw" }
      : me?.role === "admin"
      ? { to: "/admin", label: "Panel treści" }
      : { to: "/panel", label: "Moje sprawy" };

  return (
    <>
      <header className="site-head">
        <div className="site-head-inner">
          <Link to="/" className="logo">
            <b>
              {settings.brand}
              <i>.</i>
            </b>
            <span>{settings.tagline}</span>
          </Link>

          <nav className="mainnav" aria-label="Nawigacja główna">
            {MAIN.map((m) => (
              <NavLink key={m.to} to={m.to} end={m.to === "/"}>
                {m.label}
              </NavLink>
            ))}

            <div className={`navgroup${drop ? " open" : ""}`} ref={groupRef}>
              <button
                type="button"
                className="navlink"
                aria-expanded={drop}
                aria-haspopup="true"
                onClick={() => setDrop((v) => !v)}
              >
                O prawly <span className="caret">▼</span>
              </button>
              {drop && (
                <div className="drop" role="menu">
                  {ABOUT.map((a) => (
                    <Link key={a.to} to={a.to} role="menuitem">
                      <strong>{a.t}</strong>
                      <em>{a.d}</em>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </nav>

          <div className="nav-actions">
            {!me && (
              <>
                <Link to="/logowanie" className="btn line-gold sm desk">
                  Zaloguj się
                </Link>
                <Link to="/panel/nowa" className="btn gold sm desk">
                  Zamów poradę
                </Link>
              </>
            )}
            {me && (
              <>
                <NotificationBell />
                <span className="who desk">{me.full_name}</span>
                <Link to={panelLink.to} className="btn gold sm desk">
                  {panelLink.label}
                </Link>
                <Link to="/moje-konto" className="btn ghost sm desk">
                  Moje konto
                </Link>
                <button className="icon-btn desk" onClick={logout} aria-label="Wyloguj" title="Wyloguj">
                  <Icon name="wyloguj" size={19} />
                </button>
              </>
            )}

            <button
              type="button"
              className={`burger${drawer ? " on" : ""}`}
              aria-label={drawer ? "Zamknij menu" : "Otwórz menu"}
              aria-expanded={drawer}
              onClick={() => setDrawer((v) => !v)}
            >
              <i />
              <i />
              <i />
            </button>
          </div>
        </div>
      </header>

      {drawer && (
        <div className="drawer" role="dialog" aria-modal="true" aria-label="Menu">
          <div className="veil" onClick={() => setDrawer(false)} />
          <div className="drawer-panel">
            <p className="d-head">Serwis</p>
            {MAIN.map((m) => (
              <Link key={m.to} to={m.to}>
                {m.label}
              </Link>
            ))}

            <p className="d-head">O prawly</p>
            {ABOUT.map((a) => (
              <Link key={a.to} to={a.to}>
                {a.t}
              </Link>
            ))}

            <p className="d-head">Twoje konto</p>
            {!me ? (
              <>
                <Link to="/logowanie">Zaloguj się</Link>
                <Link to="/panel/nowa" className="btn gold">
                  Zamów poradę
                </Link>
              </>
            ) : (
              <>
                <Link to={panelLink.to}>{panelLink.label}</Link>
                {me.role === "client" && <Link to="/panel/nowa">Nowa sprawa</Link>}
                <Link to="/moje-konto">Moje konto</Link>
                <p className="hint" style={{ marginTop: 16 }}>Zalogowano jako {me.full_name}</p>
                <button className="btn danger" onClick={logout} style={{ marginTop: 8 }}>
                  Wyloguj
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
